<template>
  <v-dialog v-model="show" persistent="" width="500px">
    <v-card>
      <v-toolbar flat color="transparent">
        <v-toolbar-title>Create New API User</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form v-model="formState" ref="form">
        <v-container grid-list-md fluid>
          <v-alert
            :value="error"
            color="error"
            icon="error">
            {{error}}
          </v-alert>
          <v-layout column>
            <v-flex xs4>
              <v-text-field
                label="Username"
                v-model="form.user.username"
                :rules="rules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="First Name"
                v-model="form.userDetails.first_name"
                :rules="rules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="Last Name"
                v-model="form.userDetails.last_name"
                :rules="rules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="Initials"
                v-model="form.userDetails.initials"
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="Email"
                type="email"
                v-model="form.userDetails.email"
                :rules="emailRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout column>
            <v-flex xs4>
              <v-select :rules="rules" label="API Role" v-model="form.user.role" :items="roles" required></v-select>
              <v-alert
                :value="true"
                color="info"
                icon="info"
                outline>
                <p>Roles are permissions to the API</p>
                <ul>
                  <li><strong>api_editor</strong>: Can view, create, edit and use the LIMS. You most likely want to use this role</li>
                  <li><strong>api_viewer</strong>: Can only view the api, not edit data. Can not use the LIMS</li>
                  <li><strong>api_dev</strong>: Can do everything api_editor can plus create users and delete data.</li>
                </ul>
              </v-alert>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs4>
              <OrganizationAutocomplete :rules="rules" v-model="form.userDetails.organization" required>
              </OrganizationAutocomplete>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="Recommended Password"
                type="text"
                v-model="password"
                :rules="passwordRules"
              ></v-text-field>
              <v-alert
                :value="true"
                color="info"
                icon="info"
                outline>
                Provide the user with the password above.
                The user should change their password by using the API.
                <v-chip label color="black" text-color="yellow">
                  /auth/me/change_password
                </v-chip>
              </v-alert>
            </v-flex>
          </v-layout>
          <v-alert
            :value="error"
            color="error"
            icon="error">
            {{error}}
          </v-alert>
        </v-container>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="submit" :loading="saving" :disabled="invalid">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OrganizationAutocomplete from '@/components/inputs/autocomplete--organization.vue'
import UserAPI from '@/api/user.js'

export default {
  props: ['value'],
  components: {
    OrganizationAutocomplete
  },
  data () {
    return {
      formState: false,
      show: false,
      saving: false,
      form: {
        user: {
          username: null,
          role: null
        },
        userDetails: {
          first_name: null,
          last_name: null,
          initials: null,
          email: null,
          organization: null
        }
      },
      password: null,
      roles: ['api_editor', 'api_viewer', 'api_dev'],
      error: null
    }
  },
  computed: {
    rules () {
      return [v => !!v || 'Field is required']
    },
    emailRules () {
      return [...this.rules, v => /.+@.+/.test(v) || 'E-mail must be valid']
    },
    passwordRules () {
      return [...this.rules, v => v.length >= 8 || 'Password length must be minimum 8']
    },
    invalid () {
      return !this.formState
    }
  },
  created () {
    this.password = this.generatePassword()
    this.backup = JSON.stringify(this.form)
  },
  methods: {
    generatePassword () {
      const length = 8
      const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
      let retVal = ''
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      return retVal
    },
    async submit () {
      this.error = null
      this.saving = true
      const {user, userDetails} = this.form
      const password = this.password
      try {
        await UserAPI.create({user, userDetails, password})
        this.$emit('save', {})
        this.show = false
      } catch (error) {
        console.log(error)
        this.error = error.response.data.message
      } finally {
        this.saving = false
      }
    },
    reset () {
      this.form = JSON.parse(this.backup)
      this.$refs.form.resetValidation()
      this.error = null
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.reset()
      } else {
        this.password = this.generatePassword()
      }
      this.$emit('input', this.show)
    },
    value () {
      this.show = this.value
    }
  }
}
</script>

<style>

</style>
